import { CompanyRole } from "modules/company/constants";
import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "store";

const selectAuth = (state: RootState) => state.auth;
const selectUser = createSelector(selectAuth, (substate) => substate.user);

const selectRole = createSelector(selectAuth, (substate) => substate.role);

const selectUserIsSyncStatus = createSelector(
  selectAuth,
  (substate) => substate.isTokenSyncedWithServer,
);

const selectUserId = createSelector(
  selectAuth,
  (substate) => substate.user?.id ?? null,
);

const selectIsCompanyMember = createSelector(
  selectAuth,
  (substate) =>
    substate.role === CompanyRole.ASSISTANT ||
    substate.role === CompanyRole.MANAGER ||
    substate.role === CompanyRole.OWNER,
);

const selectIsCompanyOwnerOrManager = createSelector(
  selectAuth,
  (substate) =>
    substate.role === CompanyRole.MANAGER ||
    substate.role === CompanyRole.OWNER,
);

const selectIsCompanyOwner = createSelector(
  selectAuth,
  (substate) => substate.role === CompanyRole.OWNER,
);

export {
  selectAuth,
  selectUser,
  selectRole,
  selectUserIsSyncStatus,
  selectUserId,
  selectIsCompanyMember,
  selectIsCompanyOwner,
  selectIsCompanyOwnerOrManager,
};
